import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const items = [
  {
    key: "1",
    label: "How does Credit Repair work?",
    content: (
      <p>
        Credit repair works by challenging and removing negative items that
        violate FCRA laws through expertly crafted dispute letters sent to
        credit bureaus, creditors, and secondary agencies. Our meticulous
        process is designed to improve your credit score by ensuring your report
        is accurate and free from unjustified negative entries.
      </p>
    ),
  },
  {
    key: "2",
    label: "Why do I need Credit Monitoring?",
    content: (
      <p>
        Credit monitoring is essential because it provides real-time updates on
        changes to your credit report, helping you quickly spot and address
        potential issues. We use this data to import into our credit repair
        software, allowing us to efficiently track and manage your credit repair
        progress.
      </p>
    ),
  },
  {
    key: "3",
    label: "How long will it take to fix my credit?",
    content: (
      <p>
        The time it takes to fix your credit can vary depending on the
        complexity of your credit issues and the responsiveness of the credit
        bureaus. Generally, you can start seeing improvements within a few days
        to months as we systematically address and resolve negative items.
      </p>
    ),
  },
];

const Faq = () => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleItem = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <>
      <div className="custom-collapse mt-4">
        {items.map((item) => (
          <div key={item.key} className="collapse-item">
            <button
              className="collapse-header"
              onClick={() => toggleItem(item.key)}
            >
              <span>{item.label}</span>
              {activeKey === item.key ? (
                <FaChevronUp className="ml-2" />
              ) : (
                <FaChevronDown className="ml-2" />
              )}
            </button>
            {activeKey === item.key && (
              <div className="collapse-content px-4 py-2">{item.content}</div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default Faq;
